export * from './interface';
export * from './view';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/view/index.js
// module id = 351
// module chunks = 1